
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/page/[slug]",
      function () {
        return require("private-next-pages/[lang]/page/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/page/[slug]"])
      });
    }
  